import { render, staticRenderFns } from "./MaterialTestimony.vue?vue&type=template&id=8e005b00"
import script from "./MaterialTestimony.vue?vue&type=script&lang=js"
export * from "./MaterialTestimony.vue?vue&type=script&lang=js"
import style0 from "./MaterialTestimony.vue?vue&type=style&index=0&id=8e005b00&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports